import React, { useState, useEffect } from 'react'; 
import DatePicker from "react-datepicker"; 
  
import 'react-datepicker/dist/react-datepicker.css';
import '../../../assets/Style/Datepicker.css'; 


import moment from 'moment';
import { useUpdateEffect } from '../../../hooks/useUpdateEffect';
import { useTranslation } from 'react-i18next';

const DateSelect = ({ defDate, onChange, isDisabled = false, showTimeSelect = false, formatShow = "d MMM yyyy", formatIn = "YYYY-MM-DD HH:mm:ss", formatOut = "YYYY-MM-DD HH:mm:ss", ...otherProps }) => {
  const { t } = useTranslation();

    const days = [t('Mon'), t('Tue'), t('Wed'), t('Thu'), t('Fri'), t('Sat'), t('Sun')];
    const monthsFull = [t('January'), t('February'), t('March'), t('April'), t('May'), t('June'), t('July'), t('August'), t('September'), t('October'), t('November'), t('December')];
    const monthsFullShort = [t('Jan'), t('Feb'), t('Mar'), t('Apr'), t('May'), t('Jun'), t('Jul'), t('Aug'), t('Sep'), t('Oct'), t('Nov'), t('Dec')];
    const months = [t('Jan'), t('Feb'), t('Mar'), t('Apr'), t('May'), t('Jun'), t('Jul'), t('Aug'), t('Sep'), t('Oct'), t('Nov'), t('Dec')];

    const locale = {
        localize: {
            day: n => days[n],
            month: n => months[n],
            monthShort: n => monthsFullShort[n],
            monthFull: n => monthsFull[n],
        },
        formatLong: {
            date: () => 'MM/dd/yyyy',
            dateTime: () => 'MM/dd/yyyy HH:mm:ss', // Add time function to format time only
            time: () => 'HH:mm' // Add time function to format time only
        }
    };
    
 


    let initialDate;

    if (defDate && moment(defDate, formatIn).year() === 1) {
        initialDate = moment().toDate();
    } else {
        initialDate = defDate ? moment(defDate, formatIn).toDate() : null;
    }
    
    const [selectedDate, setSelectedDate] = useState(initialDate);

    useEffect(() => {
        if (selectedDate) {
            const date = moment(selectedDate).format(formatOut);
            onChange(date);
        } else {
            onChange("");
        }  
    }, [selectedDate]);

    return (
        <DatePicker 
            locale={locale}
            selected={selectedDate}
            onChange={setSelectedDate} 
            dateFormat={formatShow}
            showTimeSelect={showTimeSelect}
            timeFormat="HH:mm"  
            timeIntervals={15}    
            disabled={isDisabled} 
            
            onKeyDown={(e) => {
                e.preventDefault();
             }}
         
        {...otherProps}
        />
    );
};

export default DateSelect;